import Chip from './Chip';

export { Props } from './Chip';
export default Chip;
